/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {
    SET_COLUMNS,
    SET_GROUPING_METHODS,
    SET_FILTER_METHODS,
    SET_NEW_COLUMNS,
    SET_ALL_COLUMNS,
    SET_TARGET_GUID,
    SET_FAVORITE,
    SET_USE_GROUP_BY,
    SET_USE_LOCAL_TIME,
    SET_SPECIES_LIST_ID,
    SET_LOCAL_TIMEZONE,
    SET_SORTED,
    SET_CHECKED,
    SET_EXPANDED,
    SET_DATA,
    SET_COUNT,
    SET_PAGE,
    SET_PAGE_SIZE,
    SET_INSERT_COLUMN_ID,
    SET_IS_STALE,
    SET_SHOW_ADD,
    CHANGE_FAVORITE,
    RESET_NEW_COLUMNS,
    CLEAR_QUERY,
    SET_FILTER,
    FINISH_CHANGING_FAVORITES,
    INSERT_COLUMNS,
    FINISH_INSERT_COLUMNS,
    DELETE_COLUMNS,
    FINISH_DELETE_COLUMNS,
    RESET_FILTERS, FINISH_RESET_FILTERS, FINISH_SET_FILTER,
} from "../Actions/Types/queryToolActionTypes";

const DEFAULT_PAGE_SIZE = 100;

const initialState = {
    columns: [],
    groupingMethods: [],
    filterMethods: [],
    newColumns: [],
    allColumns: [],
    targetGuid: null,
    favorite: null,
    useGroupBy: true,
    useLocalTime: true,
    speciesListId: null,
    localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    sorted: [],
    checked: [],
    expanded: [],
    data: [],
    count: 0,
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    insertColumnId: null,
    isStale: false,
    showAdd: false,
    isChangingFavorites: false,
    isInsertingColumns: false,
    isDeletingColumns: false,
    isResettingFilters: false,
    isUpdatingFilter: false,
    skipReload: false,
};

export const queryToolReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COLUMNS:
            return {
                ...state,
                columns: action.columns,
            };
        case SET_GROUPING_METHODS:
            return {
                ...state,
                groupingMethods: action.groupingMethods,
            };
        case SET_FILTER_METHODS:
            return {
                ...state,
                filterMethods: action.filterMethods,
            };
        case SET_NEW_COLUMNS:
            return {
                ...state,
                newColumns: action.newColumns,
            };
        case SET_ALL_COLUMNS:
            return {
                ...state,
                allColumns: action.allColumns,
            };
        case SET_TARGET_GUID:
            return {
                ...state,
                targetGuid: action.targetGuid,
            };
        case SET_FAVORITE:
            return {
                ...state,
                favorite: action.favorite,
            };
        case SET_USE_GROUP_BY:
            return {
                ...state,
                useGroupBy: action.useGroupBy,
            };
        case SET_USE_LOCAL_TIME:
            return {
                ...state,
                useLocalTime: action.useLocalTime,
            };
        case SET_SPECIES_LIST_ID:
            return {
                ...state,
                speciesListId: action.speciesListId,
            };
        case SET_LOCAL_TIMEZONE:
            return {
                ...state,
                localTimezone: action.localTimezone,
            };
        case SET_SORTED:
            return {
                ...state,
                sorted: action.sorted,
            };
        case SET_CHECKED:
            return {
                ...state,
                checked: action.checked,
            };
        case SET_EXPANDED:
            return {
                ...state,
                expanded: action.expanded,
            };
        case SET_DATA:
            return {
                ...state,
                data: action.data,
            };
        case SET_COUNT:
            return {
                ...state,
                count: action.count,
            };
        case SET_PAGE:
            return {
                ...state,
                page: action.page,
            };
        case SET_PAGE_SIZE:
            return {
                ...state,
                pageSize: action.pageSize,
            };
        case SET_INSERT_COLUMN_ID:
            return {
                ...state,
                insertColumnId: action.insertColumnId,
            };
        case SET_IS_STALE:
            return {
                ...state,
                isStale: action.isStale,
            };
        case SET_SHOW_ADD:
            return {
                ...state,
                showAdd: action.showAdd,
            };
        case CHANGE_FAVORITE:
            return {
                ...state,
                favorite: action.favorite,
                columns: action.columns,
                page: 0,
                pageSize: action.definition?.pageSize ?? DEFAULT_PAGE_SIZE,
                sorted: action.definition?.sorted ?? [],
                useGroupBy: action.definition?.useGroupBy ?? false,
                useLocalTime: action.definition?.useLocalTime ?? false,
                speciesListId: action.definition?.speciesListId ?? null,
                skipReload: action.skipReload,
                isChangingFavorites: true,
            }
        case FINISH_CHANGING_FAVORITES:
            return {
                ...state,
                isChangingFavorites: false,
            };
        case RESET_NEW_COLUMNS:
            return {
                ...state,
                newColumns: [],
                checked: [],
                expanded: [],
                showAdd: false,
                targetGuid: null,
            }
        case CLEAR_QUERY:
            return {
                ...state,
                columns: [],
                newColumns: [],
                useGroupBy: true,
                useLocalTime: true,
                speciesListId: null,
                sorted: [],
                checked: [],
                expanded: [],
                data: [],
                insertColumnId: null,
                isStale: false,
                page: 0,
                count: 0,
            }
        case SET_FILTER:
            return {
                ...state,
                [action.name]: action.value,
                isUpdatingFilter: true,
            }
        case FINISH_SET_FILTER:
            return {
                ...state,
                isUpdatingFilter: false,
            }
        case INSERT_COLUMNS:
            return {
                ...state,
                columns: action.columns,
                newColumns: action.newColumns,
                showAdd: true,
                isInsertingColumns: true,
            };
        case FINISH_INSERT_COLUMNS:
            return {
                ...state,
                isInsertingColumns: false,
            };
        case DELETE_COLUMNS:
            return {
                ...state,
                columns: action.columns,
                newColumns: action.newColumns,
                isDeletingColumns: true,
            };
        case FINISH_DELETE_COLUMNS:
            return {
                ...state,
                isDeletingColumns: false,
            };
        case RESET_FILTERS:
            return {
                ...state,
                columns: action.columns,
                isResettingFilters: true,
            };
        case FINISH_RESET_FILTERS:
            return {
                ...state,
                isResettingFilters: false,
            };
        default:
            return state;
    }
};


